import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import {
  FieldRulesDetails,
  IFieldRuleConfig,
  CURRENCY_VALUE_EQUAL,
  CURRENCY_VALUE_GREATER_THAN,
  CURRENCY_VALUE_GREATER_THAN_AND_EQUAL,
  CURRENCY_VALUE_LESS_THAN,
  CURRENCY_VALUE_LESS_THAN_AND_EQUAL,
  CURRENCY_VALUE_NOT_EQUAL,
} from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { FieldProps } from "../../FormFieldSelector/interfaces";

export const getInitialRuleConfigCurrency = (
  rule: string
): IFieldRuleConfig => {
  const ruleDetails = FieldRulesDetails[rule];

  switch (rule) {
    case CURRENCY_VALUE_EQUAL:
    case CURRENCY_VALUE_NOT_EQUAL:
    case CURRENCY_VALUE_LESS_THAN:
    case CURRENCY_VALUE_LESS_THAN_AND_EQUAL:
    case CURRENCY_VALUE_GREATER_THAN:
    case CURRENCY_VALUE_GREATER_THAN_AND_EQUAL:
      return {
        rule,
        value: "",
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    default:
      return {
        rule,
        value: "",
        errorMessage: "",
      } as IFieldRuleConfig;
  }
};

export const validateCurrencyFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const value =
    fieldSubmissionValue?.value !== undefined &&
    fieldSubmissionValue?.value !== null
      ? fieldSubmissionValue.value
      : "";
  if (isRequired && !!isVisible) {
    if (value === null || value === undefined || value === ""){
      return [false, "This is a Required Field"];
    }
  }
  

  if (fieldRules && value) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[i],
        value,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  } else if (fieldRules?.length > 0) {
    return [false, "Value is required"];
  }

  return [true, ""];
};

export const validateRule = (
  fieldRule: IFieldRuleConfig,
  submissionValue: any,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { rule, value, errorMessage, subRules } = fieldRule;
  const ruleType: string = rule;
  let ruleValue: any = value;
  const ruleErrorValue: string = errorMessage;
  const isDynamicValue = fieldRule?.valueType == "dynamic";
  const dynamicValueFieldId = fieldRule?.dynamicValueFieldId;
  if (isDynamicValue && !dynamicValueFieldId) {
    return [true, ""];
  }
  const dynamicFieldData = fieldSubmissionMap[dynamicValueFieldId];
  if (isDynamicValue && !dynamicFieldData) {
    return [true, ""];
  }
  const dynamicFieldValue = `${dynamicFieldData?.fieldSubmissionValue?.value}`;
  if (isDynamicValue && dynamicFieldData) {
    ruleValue = dynamicFieldValue;
  }

  // const minValue = fieldRule?.ruleValue?.minValue;
  // const maxValue = fieldRule?.ruleValue?.maxValue;

  switch (ruleType) {
    case CURRENCY_VALUE_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) != parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case CURRENCY_VALUE_NOT_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) == parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case CURRENCY_VALUE_LESS_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) >= parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case CURRENCY_VALUE_LESS_THAN_AND_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) > parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case CURRENCY_VALUE_GREATER_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) <= parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case CURRENCY_VALUE_GREATER_THAN_AND_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) < parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;

    default:
      break;
  }
  if (fieldRule?.subRules?.length > 0) {
    const [isValidated, validatationErrorMessage] = validateSubRule(
      fieldRule,
      value,
      fieldSubmissionMap,
      validateRule
    ); // check throughly
    return [isValidated, validatationErrorMessage];
  }
  return [true, ""];
};
